import { render, staticRenderFns } from "./TablaStock.vue?vue&type=template&id=fedfa1cc"
import script from "./TablaStock.vue?vue&type=script&lang=js"
export * from "./TablaStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports